import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';

export class EstateRagFeedbackObject extends BaseEntityModel {
  id?: number;
  promptId?: number;
  messageId?: number;
  ceUserId?: number;
  value?: number;
  description?: string;
  modelType?: string;
  modelId?: number;

  constructor(model: Partial<EstateRagFeedbackObject> = {}) {
    super(model);

    this.id = model.id;
    this.promptId = model.promptId;
    this.messageId = model.messageId;
    this.ceUserId = model.ceUserId;
    this.value = model.value;
    this.description = model.description ?? '';
    this.modelType = model.modelType;
    this.modelId = model.modelId;
  }

  get isPositive(): boolean {
    return this.value === 1;
  }

  get isNegative(): boolean {
    return this.value === 0;
  }
}
